import React from 'react'
import { FiMail, FiMessageSquare, FiPhone } from 'react-icons/fi'
import { connect, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { getFormValues } from 'redux-form'
import Button from '../../../components/Template/Button'
import mapFormValuesToEvent from '../../../models/Event/mappers/mapFormValuesToEvent'
import { getUpdateReservationFormEvent } from '../../../reducers/bookingCalendar/selectors/events'
import openModal from '../../../actions/Modals/openModal'
import { Modals } from '../../Modals/ModalContainer'
import TemplateSendModal from '../../BookingCalendar/ReservationModal/TemplateSendModal'
import { isFirefox } from '../../../components/DetectBrowser/DetectBrowser'
import { is } from '../../../components/MediaQuery'
import { Mixpanel } from '../../../utils/Mixpanel'
import { getUserId } from '../../../reducers/userAccount/selectors/userAccount'

export const TemplateSendButton = ({
  modalOpen,
  event,
  isSaving = false,
  size,
  index = undefined,
  className = undefined,
  employee = undefined,
}) => {
  return (
    <Button
      data-cy={className}
      className={className}
      light
      size={size}
      style={{ borderRadius: 0, height: `${38 * size}px` }}
      onClick={() => {
        if (!isSaving) {
          if (employee) {
            Mixpanel.track(' Employees List Send An Email Screen View', {
              'Employee ID': employee ? String(employee) : undefined,
            })
          } else {
            Mixpanel.track('Reservation Form Send An Email Screen View', {
              'Reservation ID': Number(event.id),
            })
          }

          modalOpen(
            Modals.TemplateSendModal,
            <TemplateSendModal
              employee={employee}
              email={
                index !== undefined
                  ? event.roomMates[index].email
                  : event.guest.email
              }
              event={event}
            />,
          )()
        }
      }}
    >
      <FiMail size={16 * size} />
    </Button>
  )
}

export const CallButton = ({
  onClick,
  event,
  size,
  index = undefined,
  className = undefined,
  disableEvent = false,
}) => {
  const isMobile = is.mobile()
  const userId = useSelector(getUserId)

  function click() {
    onClick(() => {
      if (!disableEvent) {
        Mixpanel.track('Reservation Form Make A Phone Call', {
          'Reservation ID': event.id ? Number(event.id) : undefined,
        })
        Mixpanel.people.increment(userId, 'Phone Call Made', 1)
      }
      if (isMobile && isFirefox()) {
        const winRef = window.open(
          `tel:${
            index !== undefined
              ? event.roomMates[index].phone
              : event.guest.phone
          }`,
        )
        setTimeout(() => winRef.close(), 500)
      } else {
        window.location.href = `tel:${
          index !== undefined ? event.roomMates[index].phone : event.guest.phone
        }`
      }
    })
  }

  return (
    <Button
      className={className}
      data-cy={className}
      size={size}
      light
      style={{ borderRadius: 0, height: `${38 * size}px` }}
      onClick={click}
    >
      <FiPhone size={16 * size} />
    </Button>
  )
}

export const MessageSendButton = ({
  onClick,
  modalOpen,
  event,
  size,
  index = undefined,
  className = undefined,
  disableEvent = false,
  employee = false,
}) => {
  function click() {
    onClick(() => {
      if (employee === false) {
        Mixpanel.track('Reservation Form Send A SMS Screen View', {
          'Reservation ID': event.id ? Number(event.id) : undefined,
        })
      } else {
        Mixpanel.track('Employees List A SMS Screen View', {
          'Employee ID': employee ? employee : undefined,
        })
      }

      modalOpen(
        Modals.TemplateSendModal,
        <TemplateSendModal
          email={
            index !== undefined
              ? event.roomMates[index].phone
              : event.guest.phone
          }
          event={event}
          type={'sms'}
        />,
      )()
    })
  }

  return (
    <Button
      data-cy={className}
      className={className}
      size={size}
      light
      style={{ borderRadius: 0, height: `${38 * size}px` }}
      onClick={click}
    >
      <FiMessageSquare size={16 * size} />
    </Button>
  )
}

const mapStateToPropsCreate = state => ({
  event: mapFormValuesToEvent(getFormValues('create_reservation')(state)),
})

const mapStateToPropsUpdate = state => {
  const updatedEvent = getUpdateReservationFormEvent(state)

  return {
    event: {
      ...updatedEvent,
      ...mapFormValuesToEvent(getFormValues('update_reservation')(state)),
      booking: updatedEvent.booking,
      bookingId: updatedEvent.bookingId,
      iCalendar: updatedEvent.iCalendar,
      iCalendarId: updatedEvent.iCalendarId,
      id: updatedEvent.id,
    },
  }
}

const mapDispachToProps = (dispatch: Dispatch) => ({
  modalOpen: (id, element) => () => {
    dispatch(openModal(id, element))
  },
})

const TemplateSendButtonCreate = connect(
  mapStateToPropsCreate,
  mapDispachToProps,
)(TemplateSendButton)

const TemplateSendButtonUpdate = connect(
  mapStateToPropsUpdate,
  mapDispachToProps,
)(TemplateSendButton)

const MessageSendButtonCreate = connect(
  mapStateToPropsCreate,
  mapDispachToProps,
)(MessageSendButton)

const MessageSendButtonUpdate = connect(
  mapStateToPropsUpdate,
  mapDispachToProps,
)(MessageSendButton)

const CallButtonCreate = connect(mapStateToPropsCreate)(CallButton)

const CallButtonUpdate = connect(mapStateToPropsUpdate)(CallButton)

export {
  TemplateSendButtonCreate,
  TemplateSendButtonUpdate,
  MessageSendButtonCreate,
  MessageSendButtonUpdate,
  CallButtonCreate,
  CallButtonUpdate,
}
